import { useEffect, useState } from 'react';
import { Button, Card, Modal, Text, Tooltip, ProgressBar } from '@shopify/polaris';
import { withRouter } from 'react-router';
import { reqGetNewUserPricingPlanList, reqGetSubscription } from "../../api";
import Language from "../../i18n/Language";
import "./index.scss";
import { store } from '../../redux/store';
import { computeBestDiscount } from '../../utils/planRateCalc';

const t = Language;

const GetMoreUsageModal = (props) => {
    const {
        operaType,
        openState,
        isComboUser,
        remainQuota,

        cioPlanDataSet,
        handleOpenCwComboModal,
        getPageDataRedux,
        handleCloseGetMoreUsageModal,
        toggleToast,
    } = props;

    const [open, setOpen] = useState(false);  // 弹窗是否打开
    const [planLoading, setPlanLoading] = useState(true);  // 价格方案加载状态
    const [paidLoading, setPaidLoading] = useState(false);  // 支付加载状态
    const [userlevel, setUserlevel] = useState(1);  // 用户等级
    const [planInfoData, setPlanInfoData] = useState({
        pro: {},
        pre: {},
    });  // 预选方案
    const [planType, setPlanType] = useState('');  // 方案类型
    const [planResData, setPlanResData] = useState({});  // 价格方案数据
    const [proTrialDays, setProTrialDays] = useState(0);  // 试用天数 pro
    const [preTrialDays, setPreTrialDays] = useState(0);  // 试用天数 pre
    const [quotaType, setQuotaType] = useState(1);  // 配额类型 1 ai 2 image 3 link 4 onpage
    const [currentQuota, setCurrentQuota] = useState(0);  // 当前配额

    // 检查图标
    const checkIcon = <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M4.5 9L7.5 12L13.5 6" stroke="var(--color-primary)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>

    // 设置弹窗样式
    const changePopoverCss = (isSet = true) => {
        const STYLE_ID = 'get-more-usage-modal-size-style';
        let styleEl = document.getElementById(STYLE_ID); // 识别唯一id
        if (isSet) {
            if (!styleEl) {
                styleEl = document.createElement('style');
                styleEl.id = STYLE_ID;
                styleEl.textContent = `
                    .Polaris-Modal-Dialog__Modal.Polaris-Modal-Dialog--sizeLarge {
                        max-width: 950px;
                    }
                    .Polaris-Tooltip-TooltipOverlay__Content {
                        background-color: #1a1826;
                        color: #fdfdff;
                    }
                    .Polaris-Tooltip-TooltipOverlay .Polaris-Tooltip-TooltipOverlay__Tail,
                    .Polaris-Tooltip-TooltipOverlay .Polaris-Tooltip-TooltipOverlay__Tail path {
                        fill: #1a1826;
                    }
                    .Polaris-Tooltip-TooltipOverlay--wide {
                        max-width: 350px;
                    }
                `;
                document.head.appendChild(styleEl);
            }
        } else {
            setTimeout(() => {
                if (styleEl) {
                    styleEl.remove();
                }
            }, 500)
        }
    }

    // 获取价格方案
    const getPricingPlan = async (type = '') => {
        let _actData = store.getState().public.ActMealData;
        let _page = store.getState().page;
        let cache = _page.pageInit?.pricingPlan;
        if (Object.keys(_actData).length > 0) {
            let params = {
                activity_id: _actData.activity_id,
            };
            let res = cache || await reqGetNewUserPricingPlanList(params);
            if (res.ack === 1) {
                getPageDataRedux(res, 'pricingPlan'); // 设置价格缓存数据
                setPlanLoading(false);
                let planInfo = {
                    pro: computeBestDiscount(res.data, res.data.meal_list.month[0]),
                    pre: computeBestDiscount(res.data, res.data.meal_list.month[1]),
                }
                setPlanInfoData(planInfo);
                setProTrialDays(planInfo.pro?.trial_days || res.data.trial_days);
                setPreTrialDays(planInfo.pre?.trial_days || res.data.trial_days);
                setUserlevel(res.data.level);
                setPlanResData(res.data);

                // posthog 弹窗埋点
                props.cwreportCustomBehavior('guide_entry_exposure', {
                    source_type: "usage_limit",
                    planRes: res.data,
                    planInfo,
                    selData: (type || planType) === 'pro' ? planInfo.pro : planInfo.pre,
                });
            } else {
                toggleToast(res.msg, true);
            }

            setPlanLoading(false);
        } else {
            setTimeout(() => {
                getPricingPlan(type);
            }, 500)
        }
    }

    // 升级方案
    const handleUpgradePlan = async (type = 'pro') => {
        setPaidLoading(type);
        let selData = type === 'pro' ? planInfoData.pro : planInfoData.pre;
        // 判断是否组合付费用户 
        if (isComboUser) {
            setPaidLoading(false);
            handleOpenCwComboModal('showGetMoreUsageModal');  // 打开提示弹窗
        } else {
            // 获取套餐来源
            const _params = {
                source_type: "usage_limit",
                planRes: planResData,
                planInfo: planInfoData,
                selData,
            }
            let _t = props.handleGetPlanSource('enter_checkout', _params);

            let params = {
                ppid: selData.id,
                price: Number(selData.price),
                is_verify: 0,

                source_type: _t.source_type,
                source_position: _t.source_position,
                plan_type: _t.plan_type,
                plan_version: _t.plan_version,
                discount: _t.discount,
                paid_type: _t.paid_type,
            }
            // 活动折扣
            if (selData.rate) {
                params.activity_id = selData.activity_id;
            }
            // 优惠券折扣
            if (selData.code) {
                params.coupon_code = selData.code;
            }
            // cio埋点
            let yPrice = (selData.price / 12).toFixed(2);
            cioPlanDataSet(([2, 4].includes(selData.id) ? 'monthly' : [8, 9].includes(selData.id) ? 'annually' : ''), ([2, 8].includes(selData.id) ? 'Pro Plan' : [4, 9].includes(selData.id) ? 'Pre Plan' : ''), 0, ([8, 9].includes(selData.id) ? yPrice : selData.price));
            // posthog 弹窗埋点
            props.cwreportCustomBehavior('enter_checkout', _params);
            // 请求
            const res = await reqGetSubscription(params);
            if (res.ack === 1) {
                //跳转支付页面
                let j_url = res.data.jump_url;
                if (j_url) {
                    if (window.top) {
                        window.top.location.href = j_url;
                    } else {
                        handleJumpSubUrl(j_url);
                    }
                }
            } else {
                toggleToast(res.msg, true);
                setPaidLoading(false);
            }
        }
    }

    // 监听支付跳转
    const handleJumpSubUrl = (j_url) => {
        if (window.top) {
            window.top.location.href = j_url;
        } else {
            setTimeout(() => {
                handleJumpSubUrl(j_url);
            }, 5000)
        }
    }

    // 关闭弹窗
    const handleCloseModal = () => {
        setOpen(false);
        handleCloseGetMoreUsageModal();
    }

    // 监听弹窗打开更改宽度
    useEffect(() => {
        let _status = Boolean(openState);
        setOpen(_status);
        changePopoverCss(_status);
        setPlanType(openState); // 设置方案类型
        if (_status) {
            getPricingPlan(openState);
        }
    }, [openState]);

    // 监听配额类型
    useEffect(() => {
        setQuotaType(operaType);
    }, [operaType]);

    // 监听剩余配额
    useEffect(() => {
        setCurrentQuota(remainQuota);
    }, [remainQuota]);

    // 弹窗内容
    const modalContent = (
        <Modal
            open={open}
            onClose={handleCloseModal}
            size="large"
        >
            <div className='get-more-usage-modal'>
                {/* Header Section */}
                <div className="modal-header">
                    <Text as="h2" variant="headingLg">
                        {(userlevel === 1 && (proTrialDays > 0 || preTrialDays > 0)) ? t("Select your free trial plan to get more usage for free") : t("Upgrade your plan to get more usage")}
                    </Text>
                </div>

                {/* 进度条 */}
                <div className="quota-progress-bar">
                    <ProgressBar progress={100} size="small" animated={false} />
                    <p>
                        {userlevel === 1 ? t("Free Plan: ") : userlevel === 2 ? t("Pro Plan: ") : t("Premium Plan: ")}
                        {userlevel === 1 ? (quotaType === 'ai' ? t("{{v1}} Credits Limit Reached.", currentQuota) : quotaType === 'image' ? t("{{v1}} Images Limit Reached.", currentQuota) : quotaType === 'link' ? t("{{v1}} Links Limit Reached.", currentQuota) : quotaType === 'onpage' ? t("{{v1}} Pages Limit Reached.", currentQuota) : "-") : (userlevel === 2 && quotaType === 'onpage') ? t("{{v1}} Pages Limit Reached.", currentQuota) : "-"}
                    </p>
                </div>

                {/* Plans Container */}
                <div className="plans-container">
                    {/* Premium Plan */}
                    <div className='trial_plan_box'>
                        <div className='Most_popular'>{t("Most popular")}</div>
                        {/* 渐变背景 */}
                        <div className='trial_plan_bg'></div>
                        <Card>
                            <div className="plan-header">
                                <div className="plan-title">
                                    <Text as="h3" variant="headingMd">{t("Premium Plan")}</Text>
                                    <div className="discount-badge">{t(planInfoData.pre?.rateText)}</div>
                                </div>
                                <div className="pricing">
                                    <h2 className="original-price">${planInfoData.pre?.o_price}</h2>
                                    <h2 className="current-price">${planInfoData.pre?.price} <span>USD</span></h2>
                                </div>
                                <Text as="p" variant="bodyMd" tone="subdued">{t("Everything in Pro, plus")}</Text>
                            </div>

                            <div className="features-list">
                                <div className="feature-item">
                                    {checkIcon}
                                    <span>{t("Content Optimization")} - <span className="bold-text">500 {t("credits/mo")}</span></span>
                                </div>
                                <div className="feature-item">
                                    {checkIcon}
                                    <span>{t("On-page SEO Audit")} - <span className="bold-text color-text">{t("Unlimited")}</span> {t("pages")}</span>
                                </div>
                                <div className="feature-item">
                                    {checkIcon}
                                    <span><span className="bold-text">6000</span> {t("image compressions/mo")}</span>
                                </div>
                                <div className="feature-item">
                                    {checkIcon}
                                    <span>{t("Premium Page Speed Optimization")}</span>
                                </div>
                                <div className="feature-item">
                                    {checkIcon}
                                    <span>{t("Competitor Analysis")}</span>
                                </div>
                                {/* <div className="feature-item">
                                    {checkIcon}
                                    <Tooltip
                                        width={'wide'}
                                        content={t("Sync all indexed keywords, track their rankings, and add new keywords for ongoing management.")}
                                    >
                                        <span style={{ textDecorationLine: "underline", textDecorationStyle: "dashed", textDecorationColor: "#ccc", cursor: 'pointer' }}>{t("Keywords Rank Tracker")}</span>
                                    </Tooltip>
                                </div> */}
                            </div>

                            <div className="plan-footer">
                                {
                                    userlevel !== 3 ? <Button size="large" loading={planLoading || (paidLoading === 'pre')} disabled={Boolean(paidLoading)} variant="primary" fullWidth onClick={() => handleUpgradePlan('pre')}>
                                        {preTrialDays > 0 ? t("Try Free For {{v1}} Days", preTrialDays) : t("Get Premium Now")}
                                    </Button> : <Button size="large" loading={planLoading || (paidLoading === 'pre')} variant="primary" fullWidth disabled>
                                        {t("Current Plan")}
                                    </Button>
                                }
                                <Text as="p" variant="bodySm" tone="subdued">
                                    {
                                        planInfoData.pre?.trial_days > 0 && planInfoData.pre?.period <= 0 ? `${planInfoData.pre?.trial_days > 0 ? t("{{v1}} days free", planInfoData.pre?.trial_days) : ""}` : planInfoData.pre?.period > 0 ? `${planInfoData.pre?.trial_days > 0 ? t("{{v1}} days free, ", planInfoData.pre?.trial_days) : ""}${planInfoData.pre?.period <= 1 ? t("${{v1}} for the first month", planInfoData.pre?.price) : t("${{v1}} for {{v2}} month", planInfoData.pre?.price, planInfoData.pre?.period)}` : ""
                                    }
                                </Text>
                            </div>
                        </Card>
                    </div>

                    {/* Pro Plan */}
                    <Card>
                        <div className="plan-header">
                            <div className="plan-title">
                                <Text as="h3" variant="headingMd">{t("Pro Plan")}</Text>
                                <div className="discount-badge">{t(planInfoData.pro?.rateText)}</div>
                            </div>
                            <div className="pricing">
                                <h2 className="original-price">${planInfoData.pro?.o_price}</h2>
                                <h2 className="current-price">${planInfoData.pro?.price} <span>USD</span></h2>
                            </div>
                            <Text as="p" variant="bodyMd" tone="subdued">{t("Key Features")}</Text>
                        </div>

                        <div className="features-list">
                            <div className="feature-item">
                                {checkIcon}
                                <span>{t("Content Optimization")} - <span className="bold-text">200 {t("credits/mo")}</span></span>
                            </div>
                            <div className="feature-item">
                                {checkIcon}
                                <span>{t("On-page SEO Audit")} - <span className="bold-text">1000 {t("pages")}</span></span>
                            </div>
                            <div className="feature-item">
                                {checkIcon}
                                <span><span className="bold-text">2000</span> {t("image compressions/mo")}</span>
                            </div>
                            <div className="feature-item">
                                {checkIcon}
                                <span>{t("Pro Page Speed Optimization")}</span>
                            </div>
                            <div className="feature-item">
                                {checkIcon}
                                <Tooltip
                                    width={'wide'}
                                    content={
                                        <div className="pricing_desc_img">
                                            <img src={"/imgs/pricing/desc/StructuredDataMarkup.png"} alt='' />
                                            <img className='load_img' src='/imgs/Image/load_img.png' alt='' />
                                            <span>{t("Add JSON-LD schema to enhance search results with breadcrumbs, a site search box, product details, and more.")}</span>
                                        </div>
                                    }
                                >
                                    <span style={{ textDecorationLine: "underline", textDecorationStyle: "dashed", textDecorationColor: "#ccc", cursor: 'pointer' }}>{t("Structured Data Markup (JSON-LD)")}</span>
                                </Tooltip>
                            </div>
                        </div>

                        <div className="plan-footer">
                            {
                                userlevel !== 2 ? <Button size="large" loading={planLoading || (paidLoading === 'pro')} disabled={Boolean(paidLoading)} variant="primary" fullWidth onClick={() => handleUpgradePlan('pro')}>
                                    {proTrialDays > 0 ? t("Try Free For {{v1}} Days", proTrialDays) : t("Get Pro Now")}
                                </Button> : <Button size="large" loading={planLoading || (paidLoading === 'pro')} variant="primary" fullWidth disabled>
                                    {t("Current Plan")}
                                </Button>
                            }
                            <Text variant="bodySm" tone="subdued">
                                {
                                    planInfoData.pro?.trial_days > 0 && planInfoData.pro?.period <= 0 ? `${planInfoData.pro?.trial_days > 0 ? t("{{v1}} days free", planInfoData.pro?.trial_days) : ""}` : planInfoData.pro?.period > 0 ? `${planInfoData.pro?.trial_days > 0 ? t("{{v1}} days free, ", planInfoData.pro?.trial_days) : ""}${planInfoData.pro?.period <= 1 ? t("${{v1}} for the first month", planInfoData.pro?.price) : t("${{v1}} for {{v2}} month", planInfoData.pro?.price, planInfoData.pro?.period)}` : ""
                                }
                            </Text>
                        </div>
                    </Card>
                </div>
            </div>
        </Modal>
    );

    return modalContent;
}

export default withRouter(GetMoreUsageModal);